import { render, staticRenderFns } from "./clientForecast.vue?vue&type=template&id=63760b2b"
import script from "./clientForecast.vue?vue&type=script&lang=js"
export * from "./clientForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63760b2b')) {
      api.createRecord('63760b2b', component.options)
    } else {
      api.reload('63760b2b', component.options)
    }
    module.hot.accept("./clientForecast.vue?vue&type=template&id=63760b2b", function () {
      api.rerender('63760b2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/customerForecast/clientForecast.vue"
export default component.exports